// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__162sh","tab":"Tabs_tab__cyPVt","tabActive":"Tabs_tabActive__3AzXc"};